/**
 * Hauptaufgabe + Unteraufgaben (eltern_aufgabe_id) für Listen: Unteraufgaben erscheinen unter ihrer Hauptaufgabe statt als eigene
 * Top-Level-Einträge. Ist die Hauptaufgabe nicht in der (gefilterten) Liste, bleibt die Unteraufgabe sichtbar (mit Hinweis).
 * Reihenfolge der Hauptliste bleibt die übergebene (Sortierung der Seite), Unteraufgaben in Checklisten-Reihenfolge der Hauptaufgabe.
 */
export function gruppiereAufgaben(aufgaben) {
  const liste = Array.isArray(aufgaben) ? aufgaben : [];
  const ids = new Set(liste.map(a => a.id));
  const kinder = {};
  for (const a of liste) {
    if (a.eltern_aufgabe_id && ids.has(a.eltern_aufgabe_id) && a.eltern_aufgabe_id !== a.id) {
      (kinder[a.eltern_aufgabe_id] = kinder[a.eltern_aufgabe_id] || []).push(a);
    }
  }
  const out = [];
  for (const a of liste) {
    if (a.eltern_aufgabe_id && ids.has(a.eltern_aufgabe_id) && a.eltern_aufgabe_id !== a.id) continue;
    const k = kinder[a.id] || [];
    const reihenfolge = (a.checkliste || []).map(c => c.schluessel);
    k.sort((x, y) => {
      const ix = reihenfolge.indexOf(x.checklisten_schluessel), iy = reihenfolge.indexOf(y.checklisten_schluessel);
      return (ix < 0 ? 999 : ix) - (iy < 0 ? 999 : iy);
    });
    out.push({ aufgabe: a, kinder: k, verwaist: Boolean(a.eltern_aufgabe_id) });
  }
  return out;
}

export function fortschritt(kinder, haupt) {
  // Bevorzugt die Checkliste der Hauptaufgabe (wird beim Abhaken der Unteraufgaben mitgefuehrt) – Listen enthalten oft nur offene Aufgaben
  const cl = Array.isArray(haupt?.checkliste) ? haupt.checkliste : [];
  if (cl.length) {
    const erledigt = cl.filter(c => c.erledigt).length;
    return { n: cl.length, erledigt, text: `${erledigt}/${cl.length} Unteraufgaben erledigt` };
  }
  const n = (kinder || []).length;
  const erledigt = (kinder || []).filter(k => k.status === 'erledigt').length;
  return { n, erledigt, text: n ? `${erledigt}/${n} Unteraufgaben erledigt` : '' };
}

/** Zusammenfassen nur bei mind. 2 gewählten Aufgaben desselben Klienten, die selbst keine Unteraufgaben sind */
export function zusammenfassbar(gewaehlt) {
  const g = gewaehlt || [];
  if (g.length < 2) return false;
  const k = g[0].klient_id;
  return Boolean(k) && g.every(a => a.klient_id === k);
}

/** Titel ohne vorangestellten Klientennamen ("Name – Titel" -> "Titel"); Titel mit eigenem Gedankenstrich bleiben vollständig */
export function kurzTitel(a) {
  const t = String(a?.titel || ''), n = String(a?.betreuter_name || '');
  return n && t.startsWith(`${n} – `) ? t.slice(n.length + 3) : t;
}
